<template>
  <div class="flex flex-col items-center gap-8 py-8">
    <em
      class="mdi mdi-bluetooth text-6xl text-blue-500"
      :class="{ 'animate-pulse': isSearching }"
    />

    <div class="text-lg font-medium text-center">
      {{ isSearching ? 'Suche nach Q-Tools...' : 'Verfügbare Q-Tools' }}
    </div>

    <div
      v-if="qtools.length === 0"
      class="flex flex-col items-center gap-4 px-6 text-center text-gray-500 dark:text-gray-400"
    >
      <div class="flex items-center gap-2">
        <em class="mdi mdi-help-circle" />
        <span class="font-medium">Verbindung herstellen</span>
      </div>
      <div class="text-sm">
        <p class="font-medium">1. Gerät einschalten</p>
        <p>Drücken Sie kurz die Ein/Aus-Taste am Q-Tool.</p>
        <p class="font-medium mt-2">2. Gerät koppeln</p>
        <p>Das Q-Tool wird automatisch erkannt, sobald es eingeschaltet ist.</p>
      </div>
    </div>

    <div v-else class="w-full flex flex-col gap-2 px-4">
      <button
        v-for="qtool in qtools"
        :key="qtool.address"
        class="flex items-center gap-4 w-full rounded-lg border border-gray-200 bg-white p-4 text-left transition-colors hover:bg-gray-50 active:bg-gray-100 dark:border-dark-3 dark:bg-dark-2 dark:hover:bg-dark-3"
        :data-testid="`qtool-item-${qtool.address}`"
        @click="$emit('select', qtool.address)"
      >
        <em
          class="mdi mdi-cellphone-wireless text-xl text-gray-600 dark:text-gray-300"
        />
        <span class="flex-1 font-medium">{{ qtool.name }}</span>
        <em class="mdi mdi-chevron-right text-xl text-gray-400" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { QToolDevice } from '@/native/plugins/QTool';

defineProps<{
  qtools: QToolDevice[];
  isSearching: boolean;
}>();

defineEmits<{
  select: [address: string];
}>();
</script>
